import type { ModalQueryParamValue } from '@apps/main/new-desktop/core/models/navigation';

import type { Serializer } from '@libs/utils';

export const ModalSerializer: Serializer<ModalQueryParamValue> = {
  serialize: (modalQueryParam: ModalQueryParamValue): ModalQueryParamValue =>
    modalQueryParam,
  deserialize: (modalQueryParam: ModalQueryParamValue): ModalQueryParamValue =>
    modalQueryParam,
};
